import { set } from './just'

import {
	type GenericSchema,
	type InferOutput,
	any,
	array,
	boolean,
	brand,
	check,
	function_,
	integer,
	lazy,
	looseObject,
	maxValue,
	minValue,
	number,
	object,
	optional,
	parse,
	pick,
	picklist,
	pipe,
	record,
	safeParse,
	strictObject,
	string,
	transform,
	union,
	unknown,
} from 'valibot'

const valibot = {
	parse,
	safeParse,
	any,
	array,
	boolean,
	check,
	function_,
	number,
	object,
	strictObject,
	looseObject,
	optional,
	picklist,
	pipe,
	string,
	transform,
	union,
	brand,
	pick,
	integer,
	maxValue,
	minValue,
	unknown,
	record,
	lazy,
}
type Valibot = typeof valibot
set(window, ['R', 'libs', 'valibot'], valibot)

export {
	parse,
	safeParse,
	any,
	array,
	boolean,
	check,
	function_,
	number,
	object,
	strictObject,
	looseObject,
	optional,
	picklist,
	pipe,
	string,
	transform,
	union,
	brand,
	pick,
	integer,
	maxValue,
	minValue,
	unknown,
	record,
	lazy,
}
export type { InferOutput, GenericSchema, Valibot }
